import React, {
  useRef,
  useState,
  useImperativeHandle,
  useCallback,
} from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  DialogActions,
  Button,
  CircularProgress,
} from '@material-ui/core';
import { Form } from '@unform/web';
import axios from 'axios';
import { isFunction, isArray } from 'lodash';
import PropTypes from 'prop-types';

import { t } from '~/helpers';

import { Container } from './styles';

const Report = React.forwardRef((props, ref) => {
  const {
    open,
    onClose,
    title,
    children,
    confirm,
    cancel,
    relatorio,
    serialize,
    initials,
    validate,
    maxWidth,
    requestType,
  } = props;

  const formRef = useRef(null);
  const mobile = window.innerWidth <= 768;

  const { token } = useSelector((state) => state.auth);

  const [loading, setLoading] = useState(false);

  async function handleSubmit(param) {
    try {
      setLoading(true);

      formRef.current.setErrors({});

      const { REACT_APP_URL_DOWNLOAD } = process.env;

      await validate(param);

      const forms = isFunction(serialize) ? serialize(param) : param;

      const url = new URL(REACT_APP_URL_DOWNLOAD);
      url.search = new URLSearchParams({
        relatorio,
        token,
        ...JSON.parse(JSON.stringify(forms)),
      });

      const response = async () => {
        if (requestType == 'POST' || requestType == 'PUT') {
          let url = new URL(REACT_APP_URL_DOWNLOAD);
          url.search = new URLSearchParams({
            relatorio,
            token,
            tipo: forms.formato ? forms.formato : forms.tipo,
          });

          const res = await axios({
            url: url,
            method: requestType,
            responseType: 'blob',
            data: {
              ...forms,
            },
          });

          return res;
        } else {
          const res = await axios({
            url: url.href,
            method: requestType,
            responseType: 'blob',
          });

          return res;
        }
      };

      const resp = await response();

      if (resp.config.method.toLowerCase() == 'get') {
        let url = resp.config.url.href ?? resp.config.url
        window.open(url)
      } else {
        const file = new Blob([resp.data], { type: resp.data.type });

        const a = document.createElement('a');

        document.body.appendChild(a);

        const objectUrl = window.URL.createObjectURL(file);
        a.href = objectUrl;
        a.download = resp.data.type.includes('pdf') ? title : title + '.xls';
        a.click();
        document.body.removeChild(a);
      }


      /*
      if (resp.config.method == 'GET')
        window.open(resp.config.url.href)
      else {
        const file = new Blob([resp.data], { type: resp.data.type });

        const a = document.createElement('a');
        const objectUrl = window.URL.createObjectURL(file);
        a.href = objectUrl;
        a.download = resp.data.type.includes('pdf') ? title : title + '.xls';
        a.click();
        document.body.removeChild(a);
      }
      */


      // const file = new Blob([resp.data], { type: resp.data.type });

      // window.open(URL.createObjectURL(file));


      // const { data } = await response();

      // const file = new Blob([data], { type: data.type });

      // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      //   window.navigator.msSaveOrOpenBlob(file);
      // } else {
      //   const objectUrl = URL.createObjectURL(file);
      //   window.open(objectUrl);
      // }

      // const file = new Blob([data], { type: data.type });

      // window.open(URL.createObjectURL(file));
    } catch (err) {
      console.log(err);
      if (err.form) {
        formRef.current.setErrors(err.form);
      } else if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    } finally {
      setLoading(false);
    }
  }

  const clearField = useCallback((field) => {
    formRef.current.clearField(field);
  }, []);

  const getData = useCallback(() => {
    formRef.current.getData();
  }, []);

  const reset = useCallback(() => {
    formRef.current.reset();
  }, []);

  const setData = useCallback((data) => {
    formRef.current.setData(data);
  }, []);

  const setFieldValue = useCallback((field, value) => {
    formRef.current.setFieldValue(field, value);
  }, []);

  const setErrors = useCallback((data) => {
    formRef.current.setErrors(data);
  }, []);

  const setFieldError = useCallback((field, value) => {
    formRef.current.setFieldError(field, value);
  }, []);

  useImperativeHandle(ref, () => ({
    clearField,
    getData,
    reset,
    setData,
    setFieldValue,
    setErrors,
    setFieldError,
  }));

  return (
    <Dialog
      disableBackdropClick
      disableEscapeKeyDown
      fullWidth
      maxWidth={maxWidth}
      open={open}
      onClose={onClose}
      fullScreen={mobile}
    >
      <DialogTitle>
        <Typography variant="h6">{title}</Typography>
      </DialogTitle>
      <DialogContent>
        <Form ref={formRef} onSubmit={handleSubmit} initialData={initials}>
          <Container>{children}</Container>
        </Form>
      </DialogContent>
      <DialogActions>
        {loading ? (
          <CircularProgress
            size={20}
            color="primary"
            style={{ marginRight: '1.5rem' }}
          />
        ) : (
          <Button
            loading
            onClick={() => formRef.current.submitForm()}
            color="primary"
            variant="outlined"
          >
            {mobile ? 'Download' : confirm}
          </Button>
        )}

        <Button onClick={() => onClose()} color="secondary" variant="outlined">
          {cancel}
        </Button>
      </DialogActions>
    </Dialog>
  );
});

Report.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
  children: PropTypes.element.isRequired,
  confirm: PropTypes.string,
  cancel: PropTypes.string,
  relatorio: PropTypes.string.isRequired,
  serialize: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  initials: PropTypes.objectOf(PropTypes.any),
  validate: PropTypes.func,
  maxWidth: PropTypes.string,
  requestType: PropTypes.oneOfType(['GET', 'POST', 'PUT', 'DELETE', 'UPDATE']),
};

Report.defaultProps = {
  open: false,
  title: 'Abastek',
  confirm: 'Exibir',
  cancel: 'Cancelar',
  serialize: false,
  initials: {},
  validate: async () => { },
  maxWidth: 'sm',
  requestType: 'GET',
};

export default Report;
